import axios from 'axios'
import getVideoId from 'get-video-id'
import wiki from 'wikijs'
import { AsyncCache } from '@dinosband/dbi-utils'

const _errorUrls: string[] = []
export function isUrlWithoutPreview (url: string) {
  return _errorUrls.findIndex((i) => i === url) >= 0
}

export function addUrlWithoutPreview (url: string) {
  _errorUrls.push(url)
}

interface VideoInfo {
  id: string
  service: string | null
  embed: string
}

export function getVideoInfo (url: string) {
  const supported = [
    'youtube',
    'vimeo',
    'videopress',
    'dailymotion',
    'tiktok',
    // 'vine',
    // 'microsoftstream',
  ]
  const info = getVideoId(url) as VideoInfo
  if (info?.id && supported.includes(info?.service || '')) {
    info.embed = getVideoEmbedUrl(info)
    return info
  } else {
    // if (url.includes('tv.naver.com')) {
    //   const words = url.split('/')
    //   const id = words[words.length - 1]
    //   return {
    //     id,
    //     service: 'naver-tv',
    //     embed: 'https://tv.naver.com/embed/' + id,
    //   }
    // }
    if (url.includes('tv.kakao.com')) {
      const words = url.split('/')
      const id = words[words.length - 1]
      return {
        id,
        service: 'kakao-tv',
        embed: 'https://tv.kakao.com/embed/player/cliplink/' + id,
      }
    } else if (url.includes('vt.tiktok.com')) {
      return {
        id: url,
        service: 'tiktok',
        embed: '',
      }
    }
    return undefined
  }
}

function getVideoEmbedUrl (info: VideoInfo) {
  switch (info.service) {
    case 'youtube':
      return 'https://www.youtube.com/embed/' + info.id
    case 'vimeo':
      return 'https://player.vimeo.com/video/' + info.id
    case 'videopress':
      return 'https://videopress.com/embed/' + info.id
    case 'dailymotion':
      return 'https://www.dailymotion.com/embed/video/' + info.id
    // case 'vine':
    // case 'microsoftstream':
    // case 'tiktok':
  }
  return ''
}

export async function getTikTokEmbed (id: string) {
  let url = 'https://www.tiktok.com/oembed?url='
  if (!id.includes('vt.tiktok.com')) {
    url += 'https://www.tiktok.com/@scout2015/video/'
  }
  url += id
  const res = await axios.get(url)
  if (res) {
    return res.data
  } else {
    return undefined
  }
}

export function isWikipedia (url: string) {
  const regEx = /http[s]*:\/\/[A-Za-z]+.wikipedia.org/
  return !!url.match(regEx)
}

export function getYoutubeThumbnail (url: string) {
  const info = getVideoId(url) as VideoInfo
  return `https://img.youtube.com/vi/${info.id}/mqdefault.jpg`
}

export function isSoundCloud (url: string) {
  return url.includes('soundcloud.com')
}

export interface WikiInfo {
  title: string
  description: string
  image: string
  fullUrl: string
}

const wikiCache = new AsyncCache<string, WikiInfo>(20)

export async function getWikipedia (url: string) {
  return await wikiCache.get(url, () => getWikipediaFromNet(url))
}

async function getWikipediaFromNet (url: string): Promise<WikiInfo> {
  url = decodeURIComponent(url)
  const words = url.split('/')
  const hostname = words.find((w) => w.includes('wikipedia.org')) || 'en.wikipedia.org'
  const title = words[words.length - 1]
  // return await wiki.summary(words[words.length - 1])
  const apiUrl = `https://${hostname}/w/api.php`

  try {
    const page = await wiki({ apiUrl }).page(title)
    const description = await page.summary()
    const image = await page.mainImage()
    const fullUrl = page.url()
    return {
      title,
      description,
      image,
      fullUrl,
    }
  } catch (error) {
    return {
      title,
      description: '',
      image: '',
      fullUrl: '',
    }
  }
}
